import Roles from '@/api/roles/roles'
import fileDownload from 'js-file-download'
import router from '@/router'

const roles = new Roles()

const rolesModule = {
  namespaced: true,
  state: {
    items: [],
    item: null,
    total: 0,
  },
  getters: {
    items(state) {
      return state.items
    },
    item(state) {
      return state.item
    },
    total(state) {
      return state.total
    },
  },

  mutations: {
    SET_ITEMS: (state, roles) => {
      state.items = roles
    },
    SET_TOTAL_roles: (state, total) => {
      state.total = total
    },

    SET_ITEM: (state, school) => {
      state.item = school
    },
  },

  actions: {
    listRoles({ commit }, query) {
      return new Promise((resolve, reject) => {
        roles.listRoles(query).then(response => {
          commit('SET_ITEMS', response.roles)
          commit('SET_TOTAL_roles', response.roles.total)
          resolve(response)
        })
      })
    },
    put({ commit }, payload) {
      return new Promise((resolve, reject) => {
        roles
          .put(payload)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    getRole({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('SET_ITEM', null)
        roles
          .getRole(payload)
          .then(response => {
            commit('SET_ITEM', response)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    getUser({ commit }, payload) {
      return new Promise((resolve, reject) => {
        roles
          .getUser(payload)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
  },
}

export default rolesModule
